import React, { Children } from 'react';
import { motion } from 'framer-motion';
const listVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function WhoIsForSection() {
  const isFor = ['Eres un emprendedor que sabe que tiene un producto o servicio ganador, pero las ventas parecen haberse estancado en un número que no superas hace meses.', "Eres un trader que gana durante la semana pero lo 'devuelve' todo al mercado el viernes por un autosabotaje inconsciente.", "Sientes que eres el 'techo' de tu propio negocio y que si tú no empujas, nada funciona.", "Has invertido miles de dólares en cursos técnicos y sigues sintiendo que te 'falta algo' que no puedes nombrar.", 'Quieres que tu éxito financiero sea una herramienta de contribución para tu familia y tus hijos, y no una fuente de estrés constante.'];
  const isNotFor = ["Buscas un 'botón mágico' para hacerte millonario sin mirar tus propias sombras.", 'No estás dispuesto a ser radicalmente honesto sobre tus fracasos y tus miedos.', "Crees que el problema siempre es de 'afuera' (el gobierno, los clientes, la suerte).", 'Prefieres gastar estos $6.39 en una hamburguesa que te dará 15 minutos de placer antes que en la información que puede liberar tus próximas 7 generaciones.'];
  return <section className="py-16 md:py-[80px] px-4 bg-[#050505] border-y border-border" data-id="element-378">
      <div className="max-w-[1000px] mx-auto" data-id="element-379">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start" data-id="element-380">
          {/* IS FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[24px]" data-id="element-381">
            <div className="mb-4 font-heading text-[11px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-382">
              ✅ ESTE SISTEMA ES PARA TI SI...
            </div>
            <motion.ul className="flex flex-col gap-3" variants={listVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} data-id="element-383">
              {isFor.map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start gap-2.5 text-[13px] leading-[1.6] text-[#bbb]" data-id="element-384">
                  <div className="flex h-[18px] w-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black mt-0.5" data-id="element-385">
                    ✓
                  </div>
                  {item}
                </motion.li>)}
            </motion.ul>
          </motion.div>

          {/* IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="rounded-r-lg border border-[#3a1a1a] border-l-[4px] border-l-[#f44336] bg-[#150a0a] px-[26px] py-[24px]" data-id="element-386">
            <div className="mb-4 font-heading text-[11px] font-bold tracking-[2px] text-[#f44336] uppercase" data-id="element-387">
              ❌ NO COMPRES ESTE PRODUCTO SI...
            </div>
            <motion.ul className="flex flex-col gap-3" variants={listVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} data-id="element-388">
              {isNotFor.map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start gap-2.5 text-[13px] leading-[1.6] text-[#bbb]" data-id="element-389">
                  <div className="flex h-[18px] w-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#f44336] text-[10px] font-black text-white mt-0.5" data-id="element-390">
                    ✕
                  </div>
                  {item}
                </motion.li>)}
            </motion.ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mt-12 overflow-hidden rounded-[10px] border-2 border-border" data-id="element-391">
          <img src="https://cdn.magicpatterns.com/uploads/hbep8AxXYk6bTvf9tkdLWr/Imagen_Codigo_de_identidad-5.png" alt="Hombre leyendo en biblioteca" className="w-full h-auto object-cover grayscale opacity-70 hover:grayscale-0 transition-all duration-500" data-id="element-392" />
        </motion.div>
      </div>
    </section>;
}